<template>
  <div name="doublepicker">

        <div class="mt-2 p-5 w-32 mx-auto bg-white rounded-lg shadow-xl">
          <div class="w-full text-xs text-center"><span class="pr-10">m</span><span class="">{{secondaryKey}}</span></div>
          <div class="flex">

            <select name="minutes" v-model="primary" @change="onChange($event)" 
            class="bg-transparent text-2xl appearance-none outline-none cursor-pointer text-center">
              <option v-for="(minute, i) in divideValue" :key="minute" v-bind:value="i">{{formatNumber(i)}}</option>
            </select>
            <span class="text-xl mr-1">:</span>
            <select name="seconds" v-model="secondary" @change="onChange($event)" 
            class="bg-transparent text-2xl appearance-none outline-none mr-4 cursor-pointer text-left">
               <option v-for="(second, i) in divideValue" :key="second" v-bind:value="i">{{formatNumber(i)}}</option>
            </select>
          </div>
        </div>

  </div>
</template>

<script>
export default {
  name: "doublepicker",
     props: {
      value: {type: Number, required: true},
      layout: {type: String, required: true},
    },
  computed: {
    secondaryKey() {
      return this.layout === 'time' ? 's' : 'cm'
    },
  },
  mounted () {
    this.setValue()
  },
  data () {
    return {
      primary: 0,
      secondary: 0,
      count: this.value === undefined ? 0 : this.value,
      divideValue: this.layout === 'time' ? 60 : 100
    }
  },
   watch: {
    count: function (val) {
      this.$emit('countChange', val)
    },
  },
   methods: {
    formatNumber(n) {
       return (n < 10 ? '0' : '') + n
    },
    setValue() {
      this.primary = Math.floor(this.value / this.divideValue),
      this.secondary = (this.value - this.primary * this.divideValue)
    },
    onChange() {
      let newValue = Math.floor(this.primary * this.divideValue) + this.secondary
      this.count = newValue
    }
   }

};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

select {
  height: 1.5em !important;
  width: auto !important;
}
</style>